export default {
    "/": {
        "title": "Taoify - Platform Pembinaan Laman Web E-Dagang Antarabangsa | Barangan China, Jual ke Seluruh Dunia",
        "desc": "Taoify memasukkan pembinaan laman, penterjemahan, penempatan produk, penghantaran, pembayaran, dan pemasaran dalam satu panel pentadbiran: 18 pekerja AI membantu anda, buka kedai dalam 20 bahasa, jual barangan China ke seluruh dunia."
    },
    "/feature": {
        "title": "Fungsi · Semua yang diperlukan untuk membuka kedai, ada di halaman ini · Taoify",
        "desc": "Pembinaan laman, penterjemahan, penempatan produk, penghantaran, pembayaran, dan menarik pelanggan – Taoify meletakkan 15 modul yang diperlukan untuk menjual antarabangsa dalam satu panel, tidak perlu lagi menggunakan beberapa alat dari luar."
    },
    "/ai-staff": {
        "title": "Pekerja AI · 18 pekerja AI, yang paling sibuk adalah mereka yang menarik trafik · Taoify",
        "desc": "Dari 18 pekerja AI, 5 daripada kumpulan pertumbuhan khusus menyelesaikan masalah 'tiada orang datang': 12 item pemeriksaan kedai, pelan pemasaran 30 hari, ubah satu produk menjadi hasil untuk 9 saluran, e-mel pemasaran automatik untuk mengundang pembeli kembali."
    },
    "/logistics": {
        "title": "Logistik Antarabangsa · Dari tangan anda ke tangan pelanggan · Taoify",
        "desc": "Pengangkutan awal, pembebasan, pengangkutan utama, dan penghantaran akhir, tiga laluan dipilih berdasarkan barang dan masa. YunTu, Yanwen, 4PX telah disambungkan, label penghantaran, jejak, dan penyelesaian isu semuanya dalam satu panel."
    },
    "/payment": {
        "title": "Pembayaran dan Penyelesaian · Pelanggan boleh bayar dengan cara yang mudah bagi mereka · Taoify",
        "desc": "PayPal, Stripe, kad kredit, Alipay siap digunakan. Terima mata wang asing, ambil keluar dalam RMB, penyelesaian T+7, kadar dan masa pengesahan ditunjukkan dengan jelas."
    },
    "/pricing": {
        "title": "Harga · Pakej Langganan + Komisen Bertingkat · Taoify",
        "desc": "Kedai dikenakan caj berdasarkan pakej langganan: Basic $15/sebulan, Standard $29/sebulan, Premium $59/sebulan, lebih murah jika dibayar suku tahunan atau tahunan. Komisen transaksi bertingkat mengikut jumlah transaksi bulanan, minimum 3%."
    },
    "/cases": {
        "title": "Kes Testimoni Penjual · Mereka Juga Melakukannya · Taoify",
        "desc": "Aksesori Yiwu, 3C Shenzhen, pakaian Guangzhou, dan penjual dari Jerman, AS, Perancis - enam orang, enam titik permulaan, satu set cara yang sama."
    },
    "/sign-up": {
        "title": "Buka Toko - Daftar Percuma dengan Taoify",
        "desc": "Dibangunkan dalam 10 minit, tanpa kod, percubaan pakej langganan dengan semua ciri. Daftar sekarang dengan Taoify untuk memulakan perjalanan e-dagang antarabangsa anda."
    },
    "/for-china-sellers": {
        "title": "Untuk Penjual China · Anda Hanya Pilih Produk dan Tetapkan Harga, Kami Uruskan Sisanya · Taoify",
        "desc": "Pembinaan laman web, penterjemahan, penghantaran, pencetakan label, menjawab pelanggan - platform ini akan menguruskan segala perkara rumit tersebut. Pakej langganan + komisen bertingkat (sehingga 3%)."
    },
    "/for-global-sellers": {
        "title": "Untuk Penjual Luar Negeri: Pilih Produk di Rak China, Jual di Toko Anda Sendiri · Taoify",
        "desc": "Tiada stok tekanan, tiada simpanan: Pilih produk dari rantaian bekalan China, dikirim langsung dari gudang China setelah pesanan diterima, anda mendapat keuntungan dari selisih harga. BuyLink juga boleh menukar pautan 1688, Taobao menjadi produk anda sendiri."
    },
    "/template-index": {
        "title": "Pasaran Templat - Templat Laman Web Profesional Taoify",
        "desc": "Templat laman web profesional untuk projek manapun, banyak templat industri percuma untuk digunakan, disesuaikan dengan keperluan imej dan fungsi merek anda."
    },
    "/question": {
        "title": "Pusat Bantuan · Cari Jawapan Di Sini Dahulu · Taoify",
        "desc": "Buka toko, dekorasi, muat naik, logistik pesanan, pembayaran, pemasaran, hak akses akaun - soalan-soalan biasa disusun mengikut kategori, jika tidak jumpa, hantar tiket sokongan."
    },
    "/about-us": {
        "title": "Tentang Taoify · Apa yang Kami Lakukan",
        "desc": "Taoify adalah platform pembuatan laman web serba dalam satu untuk penjual antarabangsa: pembuatan laman, penterjemahan, pemuatannya, logistik, pembayaran, dan pemasaran dapat diselesaikan dalam satu dasbor."
    },
    "/privacy-policy": {
        "title": "Dasar Privasi · Taoify",
        "desc": "Bagaimana Taoify mengumpul, menggunakan, menyimpan, dan melindungi maklumat peribadi anda, serta hak yang anda miliki terhadap data anda."
    },
    "/terms-service": {
        "title": "Syarat Perkhidmatan · Taoify",
        "desc": "Terma dan syarat penggunaan perkhidmatan platform Taoify: akaun, kedai, pesanan, penyelesaian, dan pembahagian tanggungjawab."
    },
    "/consumer-agreement": {
        "title": "Dasar Pengembalian Wang · Taoify",
        "desc": "Peraturan pengembalian wang dan servis purna jual untuk pesanan di platform Taoify: syarat permohonan, tempoh pemprosesan, dan kaedah pembayaran."
    },
    "/user-agreement": {
        "title": "Perjanjian Pengguna · Taoify",
        "desc": "Sila baca: Panduan Pendaftaran Akaun, Garis Panduan Pengurusan Kedai, dan Huraian Perkhidmatan Platform sebelum mendaftar dan menggunakan Taoify."
    }
}
